const night = () => {
  let objects = {
    bottom: '#12132E',
    middle: '#233763',
    top: '#345D9A'
  }

  return objects
}

export default night()